"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeLeaderboard = ChallengeLeaderboard;
Object.defineProperty(exports, "fakeEmployees", {
  enumerable: true,
  get: function () {
    return _fakeItems.fakeEmployees;
  }
});
exports.individualChallengeLeaderboardPageSize = void 0;
var _Paper2 = _interopRequireDefault(require("@mui/material/Paper"));
var _TableContainer2 = _interopRequireDefault(require("@mui/material/TableContainer"));
var _Table2 = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody2 = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableHead2 = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow2 = _interopRequireDefault(require("@mui/material/TableRow"));
var _TableCell2 = _interopRequireDefault(require("@mui/material/TableCell"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Tabs2 = _interopRequireDefault(require("@mui/material/Tabs"));
var _Tab2 = _interopRequireDefault(require("@mui/material/Tab"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _bronze = _interopRequireDefault(require("../../assets/images/medals/bronze-2.svg"));
var _bronze2 = _interopRequireDefault(require("../../assets/images/medals/bronze.svg"));
var _gold = _interopRequireDefault(require("../../assets/images/medals/gold-2.svg"));
var _gold2 = _interopRequireDefault(require("../../assets/images/medals/gold.svg"));
var _silver = _interopRequireDefault(require("../../assets/images/medals/silver-2.svg"));
var _silver2 = _interopRequireDefault(require("../../assets/images/medals/silver.svg"));
var _stars = _interopRequireDefault(require("../../assets/images/medals/stars.svg"));
var _environment = require("../../environment");
var _hooks = require("../../hooks");
var _services = require("../../services");
var _button = require("../button");
var _contactDialog = require("../contact-dialog");
var _icons = require("../icons");
var _user = require("../user");
var _fakeItems = _interopRequireWildcard(require("./fake-items"));
var _item = _interopRequireDefault(require("./item"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const companyTabs = [{
  key: 'individual',
  labelKey: 'commons.challenge_details.competition_types.individual'
}, {
  key: 'companyTeam',
  labelKey: 'commons.challenge_details.competition_types.teams'
}, {
  key: 'companySite',
  labelKey: 'commons.challenge_details.competition_types.sites'
}, {
  key: 'companySubsidiary',
  labelKey: 'commons.challenge_details.competition_types.subsidiaries'
}, {
  key: 'companyRegion',
  labelKey: 'commons.challenge_details.competition_types.regions'
}];
const podiumRankMap = {
  1: {
    bgColor: '#ECFBF4',
    heightRatio: 1,
    individualMedal: _gold.default,
    teamMedal: _gold2.default
  },
  2: {
    bgColor: '#F3F6FF',
    heightRatio: 0.95,
    individualMedal: _silver.default,
    teamMedal: _silver2.default
  },
  3: {
    bgColor: '#FFEEE0',
    heightRatio: 0.9,
    individualMedal: _bronze.default,
    teamMedal: _bronze2.default
  }
};
const individualChallengeLeaderboardPageSize = exports.individualChallengeLeaderboardPageSize = 100;
function ChallengeLeaderboard({
  Button: _Button,
  Dialog,
  FakeItemsCard,
  disableLeaderboardRetrieval,
  fullLeaderboardsDisabled,
  disableTitle,
  enablePodium,
  disableContact,
  currentPartner,
  geogroup,
  currentUser,
  teams,
  subsidiaries,
  regions,
  sites,
  userType,
  downloading,
  exporting,
  enableCompetitionTypes,
  challenge,
  isEventWithOffer,
  userChallenge,
  displayType,
  leaderboard,
  count,
  subgroup,
  setDisplayType,
  setLeaderboard,
  setCount,
  onRowClick,
  handleExport
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [podium, setPodium] = (0, _react.useState)();
  const [closeLeaderboard, setCloseLeaderboard] = (0, _react.useState)([]);
  const [page, setPage] = (0, _react.useState)(1);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [selectedUsers, selectUsers] = (0, _react.useState)({});
  const [contactDialogOpen, openContactDialog] = (0, _react.useState)(false);
  const initialDisplayType = (0, _react.useRef)(null);
  const podiumInitialized = (0, _react.useRef)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    palette
  } = (0, _styles.useTheme)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  const {
    cancellablePromise: cancellableCloseLeaderboardPromise,
    cancelPromises: cancelCloseLeaderboardPromise
  } = (0, _hooks.useCancellablePromise)();
  const {
    getProgressValue
  } = (0, _hooks.useChallenge)();
  const {
    toOrdinal
  } = (0, _hooks.useUnits)();
  (0, _react.useEffect)(() => {
    setInitialized(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (initialized && challenge && displayType && !disableLeaderboardRetrieval) {
      if (!initialDisplayType.current) initialDisplayType.current = displayType;
      getLeaderboard(1);
    }
    return () => {
      cancelPromises();
      setPage(1);
      if (!disableLeaderboardRetrieval) setLeaderboard?.(undefined);
    };
  }, [initialized, challenge, displayType]);
  (0, _react.useEffect)(() => {
    if (currentUser && challenge && displayType === 'individual' && userChallenge && userChallenge.leaderboardIndex !== undefined && userChallenge.leaderboardIndex >= _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount) {
      getCloseLeaderboard(currentUser, challenge, userChallenge.leaderboardIndex + 1);
    }
    return () => {
      cancelCloseLeaderboardPromise();
      setCloseLeaderboard([]);
    };
  }, [challenge, userChallenge, displayType]);
  (0, _react.useEffect)(() => {
    if (initialized && page > 1) {
      getLeaderboard(page);
    }
  }, [page]);
  async function getLeaderboard(page) {
    if (!challenge || !displayType || disableLeaderboardRetrieval) return;
    setLoading(true);
    try {
      if (displayType === 'individual') {
        const {
          leaderboard: pageLeaderboard,
          count
        } = await cancellablePromise(_services.GeogroupService.getChallengeLeaderboard(challenge.id, {
          page,
          pageSize: fullLeaderboardsDisabled ? _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount : individualChallengeLeaderboardPageSize,
          subgroup
        }));
        if (enablePodium && !podiumInitialized.current && initialDisplayType.current === displayType) {
          setPodium(pageLeaderboard.length < 3 ? null : [pageLeaderboard[1], pageLeaderboard[0], pageLeaderboard[2]]);
          podiumInitialized.current = true;
        }
        const displayedLeaderboard = page === 1 ? pageLeaderboard : [...(leaderboard || []), ...pageLeaderboard];
        setCount?.(Math.min(count, challenge.nbMembers));
        setLeaderboard?.(displayedLeaderboard);
      } else if (currentPartner) {
        if (fullLeaderboardsDisabled && _environment.defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount <= 0) {
          setPodium(null);
          setCount?.(10);
          setLeaderboard?.([]);
          podiumInitialized.current = true;
        } else {
          const leaderboard = await cancellablePromise(_services.GeogroupService.getChallengeLeaderboardBySubGroups(currentPartner, challenge.id, {
            subGroupDisplay: displayType
          }));
          if (enablePodium && !podiumInitialized.current && initialDisplayType.current === displayType) {
            setPodium(leaderboard.length < 3 ? null : [leaderboard[1], leaderboard[0], leaderboard[2]]);
            podiumInitialized.current = true;
          }
          setCount?.(leaderboard.length);
          setLeaderboard?.(fullLeaderboardsDisabled ? [...leaderboard].slice(0, _environment.defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount) : leaderboard);
        }
      }
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.challenge_details.server_error_awards'), {
          variant: 'error'
        });
      }
    }
    setLoading(false);
  }
  async function getCloseLeaderboard(currentUser, challenge, leaderboardIndex) {
    try {
      const closeLeaderboard = (await cancellableCloseLeaderboardPromise(Promise.all([leaderboardIndex % 3 === 1 && leaderboardIndex > _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount + 1 ? _services.GeogroupService.getChallengeLeaderboard(challenge.id, {
        page: leaderboardIndex - 1,
        pageSize: 1,
        subgroup
      }) : {
        leaderboard: []
      }, _services.GeogroupService.getChallengeLeaderboard(challenge.id, {
        page: Math.round(leaderboardIndex / 3),
        pageSize: 3,
        subgroup
      }), leaderboardIndex % 3 === 0 ? _services.GeogroupService.getChallengeLeaderboard(challenge.id, {
        page: leaderboardIndex + 1,
        pageSize: 1,
        subgroup
      }) : {
        leaderboard: []
      }]))).flatMap(({
        leaderboard
      }) => leaderboard);
      const index = closeLeaderboard.findIndex(({
        id
      }) => id === currentUser.id);
      setCloseLeaderboard(closeLeaderboard.slice(Math.max(0, index - 1), index + 2).filter(({
        leaderboardIndex
      }) => typeof leaderboardIndex === 'number' && leaderboardIndex > _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount));
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
  }
  const selectedCount = Object.values(selectedUsers).filter(Boolean).length;
  const allSelected = selectedCount === leaderboard?.length;
  const Button = _Button || _button.Button;
  const isCompany = geogroup && geogroup.type === 'company' && Boolean(currentPartner) || false;
  const displaySubgroups = !fullLeaderboardsDisabled && !challenge?.isLocal;
  const isTeamPodium = initialDisplayType.current !== 'individual';
  const teamLeaderboard = challenge && userChallenge && userChallenge.subgroupsLeaderboards?.find(({
    subGroupType
  }) => subGroupType === displayType) || null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !disableTitle && !exporting && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    height: 42,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.25rem",
    fontWeight: 600
  }, t('commons.challenges.awards'))), challenge && enablePodium && podium && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-end",
    display: {
      xs: 'none',
      lg: 'flex'
    },
    gap: 2,
    marginBottom: 3,
    marginTop: 12
  }, podium.map((item, index) => {
    const {
      bgColor,
      heightRatio,
      individualMedal,
      teamMedal
    } = podiumRankMap[item?.rank || index + 1];
    return /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      bgcolor: bgColor,
      borderRadius: 4,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      key: index,
      width: "calc((100% - 32px) / 3)"
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      marginTop: -9,
      sx: challenge.period === 'past' && item?.rank === 1 ? {
        backgroundImage: `url(${_stars.default})`,
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '200px auto'
      } : {},
      width: "100%"
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      bgcolor: bgColor,
      borderRadius: 15,
      display: "flex",
      height: 102,
      justifyContent: "center",
      width: 102
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      bgcolor: "#fff",
      border: "1px solid #DDE0E7",
      borderRadius: 12,
      height: 96,
      width: 96
    }, isTeamPodium || !item ? /*#__PURE__*/_react.default.createElement("img", {
      height: "100%",
      src: teamMedal,
      width: "100%"
    }) : /*#__PURE__*/_react.default.createElement(_user.UserAvatar, {
      bgColor: "#fff",
      color: palette.primary.main,
      size: 94,
      user: item
    })))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      height: 220 * heightRatio,
      justifyContent: item ? 'flex-start' : 'center',
      paddingBottom: 3,
      paddingTop: 3,
      paddingX: 3,
      width: "100%"
    }, item ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isTeamPodium && item && /*#__PURE__*/_react.default.createElement(_Box2.default, {
      marginTop: -5.5
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: individualMedal,
      width: 88
    })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      noWrap: true,
      align: "center",
      fontSize: "1.15rem",
      fontWeight: 700
    }, item.username || t('commons.news.deleted_user')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      noWrap: true,
      align: "center",
      fontSize: "1.1rem",
      fontWeight: 700
    }, getProgressValue(challenge.type, item.progressValue)), /*#__PURE__*/_react.default.createElement(_Box2.default, {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: 1
    }, isTeamPodium && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      noWrap: true,
      align: "center",
      variant: "body2"
    }, t('commons.challenges.participants', {
      count: item.participants || 0
    })), isTeamPodium && item.participants && item.progressValue ? /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      noWrap: true,
      align: "center",
      variant: "body2"
    }, t('commons.stats.on_average', {
      value: getProgressValue(challenge.type, item.progressValue / item.participants)
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      align: "center",
      fontSize: "1.15rem",
      fontWeight: 700
    }, "/"))));
  })), !exporting && challenge && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 3
  }, isCompany && enableCompetitionTypes ? /*#__PURE__*/_react.default.createElement(_Tabs2.default, {
    onChange: (_, type) => setDisplayType?.(type),
    scrollButtons: false,
    sx: {
      flexGrow: 1
    },
    value: displayType,
    variant: "scrollable"
  }, companyTabs.filter(({
    key
  }) => {
    if (key === 'companySite') return sites && sites.length >= 2;
    if (key === 'companyTeam') return teams && teams.length >= 2;
    if (key === 'companySubsidiary') return subsidiaries && subsidiaries.length >= 2;
    if (key === 'companyRegion') return regions && regions.length >= 2;
    return true;
  }).map(({
    key,
    labelKey
  }) => {
    const isDefault = challenge.collaborationType === 'individual' || !challenge.subGroupDisplay ? key === 'individual' : challenge.subGroupDisplay === key;
    return {
      key,
      isDefault,
      labelKey
    };
  }).sort(a => a.isDefault ? -1 : 1).map(({
    key,
    labelKey,
    isDefault
  }) => {
    return /*#__PURE__*/_react.default.createElement(_Tab2.default, {
      key: key,
      label: t(isDefault ? 'commons.challenge_details.competition_types.default' : labelKey),
      sx: {
        textTransform: 'initial'
      },
      value: key
    });
  })) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexGrow: 1
  }), handleExport && challenge.period !== 'future' && (displayType === 'individual' || !fullLeaderboardsDisabled || _environment.defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount > 0) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(Button, {
    disabled: downloading || !challenge || !leaderboard || count === undefined,
    onClick: ({
      currentTarget
    }) => handleExport(currentTarget),
    size: "small",
    startIcon: downloading ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_icons.ExportIcon, null),
    variant: "outlined"
  }, t('commons.actions.export')))), challenge && challenge.period !== 'future' && (displayType === 'individual' ? userChallenge?.rank && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #9CBDF4",
    borderRadius: 2,
    padding: 2,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, leaderboard ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("span", {
      key: 0
    })],
    i18nKey: "commons.challenge_details.rank",
    values: {
      nbMembers: count,
      rank: toOrdinal(userChallenge.rank, {
        inclusive: true
      })
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  }))) : !fullLeaderboardsDisabled && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #9CBDF4",
    borderRadius: 2,
    padding: 2,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, leaderboard ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("span", {
      key: 0
    })],
    i18nKey: "commons.challenges.rank_team",
    values: {
      rank: teamLeaderboard ? toOrdinal(teamLeaderboard.rank, {
        feminine: true
      }) : '-',
      count: teamLeaderboard?.countSubgroupOfSameType || '-'
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })))), !exporting && !disableContact && selectedCount > 0 && displayType === 'individual' && userType === 'admin' && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#F3F6FF",
    borderRadius: 4,
    display: "flex",
    gap: 3,
    justifyContent: "space-between",
    paddingX: 3,
    paddingY: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary"
  }, t('commons.challenge_details.table.selected_members', {
    count: selectedCount
  })), /*#__PURE__*/_react.default.createElement(Button, {
    disabled: !leaderboard || selectedCount === 0,
    onClick: () => openContactDialog(true),
    startIcon: /*#__PURE__*/_react.default.createElement(_icons.ContactIcon, null),
    variant: "contained"
  }, t('commons.actions.contact'))), /*#__PURE__*/_react.default.createElement(_TableContainer2.default, {
    component: _Paper2.default,
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_Table2.default, null, /*#__PURE__*/_react.default.createElement(_TableHead2.default, null, /*#__PURE__*/_react.default.createElement(_TableRow2.default, null, !exporting && !disableContact && displayType === 'individual' && userType === 'admin' && /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    align: "center",
    padding: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
    checked: allSelected,
    color: "primary",
    disabled: !leaderboard,
    indeterminate: !allSelected && selectedCount > 0,
    onChange: () => {
      if (selectedCount > 0) selectUsers({});else selectUsers(leaderboard?.reduce((res, {
        id
      }) => {
        if (id) res[id] = true;
        return res;
      }, {}) || {});
    },
    size: "small"
  })), /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    align: "center",
    padding: "checkbox",
    sx: {
      width: 42
    }
  }, "#"), /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, displayType === 'individual' ? t('commons.challenge_details.table.pseudonym') : displayType === 'companySite' ? t('commons.challenge_details.table.site') : displayType === 'companySubsidiary' ? t('commons.challenge_details.table.subsidiary') : displayType === 'companyRegion' ? t('commons.challenge_details.table.region') : t('commons.challenge_details.table.team')), displayType !== 'individual' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, t('commons.challenge_details.table.participants')), /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, t('commons.challenge_details.table.average_per_participant'))), isCompany && displayType === 'individual' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyTeam') && teams !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, t('commons.challenge_details.table.site')), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySite') && sites !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, t('commons.challenge_details.table.team')), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySubsidiary') && subsidiaries !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, t('commons.challenge_details.table.subsidiary')), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyRegion') && regions !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, t('commons.challenge_details.table.region'))), (!challenge || challenge.type !== 'noTarget') && /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    style: {
      textAlign: 'end',
      width: 150
    }
  }, challenge ? t('commons.challenge_details.table.performance', {
    context: challenge.type === 'bttf' ? 'bttf' : challenge.type === 'traveledDistance' ? 'distance' : challenge.type === 'cyclingDays' ? 'days' : challenge.type === 'homeWorkJourneysCount' || challenge.type === 'journeysCount' ? 'journeys' : ''
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  })))), /*#__PURE__*/_react.default.createElement(_TableBody2.default, null, challenge && leaderboard ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, leaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(_item.default, {
    challenge: challenge,
    disableContact: disableContact,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    index: index,
    isCompany: isCompany,
    item: item,
    key: item.id || index,
    leaderboard: leaderboard,
    onRowClick: item.id ? onRowClick : undefined,
    own: currentUser?.id === item.id,
    regions: regions,
    selectedUsers: selectedUsers,
    selectUsers: selectUsers,
    sites: sites,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  })), closeLeaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(_item.default, {
    challenge: challenge,
    dashed: index === 0,
    disableContact: disableContact,
    disableRank: index === 0 && closeLeaderboard[0].rank === leaderboard[leaderboard.length - 1].rank,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    index: index,
    isCompany: isCompany,
    item: item,
    key: item.id || index,
    leaderboard: closeLeaderboard,
    onRowClick: item.id ? onRowClick : undefined,
    own: currentUser?.id === item.id,
    regions: regions,
    selectedUsers: selectedUsers,
    selectUsers: selectUsers,
    sites: sites,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  }))) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_item.default, {
    challenge: challenge,
    disableContact: disableContact,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    index: index,
    isCompany: isCompany,
    key: index,
    leaderboard: leaderboard,
    regions: regions,
    selectedUsers: selectedUsers,
    sites: sites,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  }))), fullLeaderboardsDisabled && count !== undefined && (displayType === 'individual' ? count > _environment.defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount : count > _environment.defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount) && /*#__PURE__*/_react.default.createElement(_fakeItems.default, {
    Card: FakeItemsCard,
    challenge: challenge,
    disableContact: disableContact,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    isCompany: isCompany,
    isEventWithOffer: isEventWithOffer,
    leaderboard: leaderboard,
    regions: regions,
    selectedUsers: selectedUsers,
    sites: sites,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  }))), !fullLeaderboardsDisabled && !exporting && displayType === 'individual' && (count === undefined || !leaderboard || leaderboard.length < count) && /*#__PURE__*/_react.default.createElement(Button, {
    disabled: count === undefined || !leaderboard || loading,
    onClick: () => setPage(page + 1),
    size: "medium",
    startIcon: loading && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    sx: {
      alignSelf: 'center'
    },
    variant: "outlined"
  }, t('commons.challenge_details.table.see_more')), /*#__PURE__*/_react.default.createElement(_contactDialog.ContactDialog, {
    Button: Button,
    challenge: challenge,
    currentUser: currentUser,
    Dialog: Dialog,
    onClose: () => {
      openContactDialog(false);
      selectUsers({});
    },
    open: contactDialogOpen,
    selectedUsersIds: leaderboard?.reduce((res, {
      id
    }) => {
      if (id && selectedUsers[id]) res.push(id);
      return res;
    }, []) || []
  }));
}